<template>
  <div id="about" class="text-center position-relative">
    <div class="container position-relative py-5">
      <h1 class="title">{{ $t('section.about') }}</h1>
      <hr class="w-25 bg-primary mt-1"/>

      <p>{{ $t('about.description') }}</p>

      <div class="row py-5">

        <div class="col-12 col-md-4 d-flex align-items-center justify-content-center">
          <img src="../assets/images/me.jpg" class="img-thumbnail mx-auto rounded-circle mb-3" />
        </div>

        <div class="col-12 col-md-8">
          <div class="h-100 d-flex align-items-center justify-content-center">
            <div class="row">
              <div class="col-6 p-2 quality">
                <i class="far fa-clock text-primary"></i>
                <h3>{{ $t('about.idea1.title') }}</h3>
                <p>{{ $t('about.idea1.description') }}</p>
              </div>

              <div class="col-6 p-2 quality">
                <i class="fas fa-reply-all text-primary"></i>
                <h3>{{ $t('about.idea2.title') }}</h3>
                <p>{{ $t('about.idea2.description') }}</p>
              </div>

              <div class="col-6 p-2 quality">
                <i class="fas fa-tools text-primary"></i>
                <h3>{{ $t('about.idea3.title') }}</h3>
                <p>{{ $t('about.idea3.description') }}</p>
              </div>

              <div class="col-6 p-2 quality">
                <i class="fas fa-users text-primary"></i>
                <h3>{{ $t('about.idea4.title') }}</h3>
                <p>{{ $t('about.idea4.description') }}</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <Divider/>
  </div>
</template>

<script>
import Divider from './Layout/Divider.vue'

export default {
  name: 'about',
  components: { Divider }
}
</script>

<style scoped>
.timeline::before {
  content: "2011";
  position: absolute;
  left: 3rem;
  float: left;
  font-size: 30px;
}

.timeline::after {
  content: "Now";
  position: absolute;
  right: 3rem;
  float: right;
  font-size: 30px;
}

.quality > i {
  font-size: 60px;
}
</style>
